import { toast } from "sonner";
import { AdminShell } from "@project/admin/components/admin-shell";
import { SectionCard } from "@project/admin/components/module-ui";
import { Input } from "@project/components/ui/input";
import { Textarea } from "@project/components/ui/textarea";
import { Label } from "@project/components/ui/label";
import { Button } from "@project/components/ui/button";
import { FamilyDetails } from "@project/admin/components/family-details";
import { Save } from "lucide-react";

function F({
  label,
  full = false,
  children,
}: {
  label: string;
  full?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div className={full ? "md:col-span-2 lg:col-span-3" : ""}>
      <Label className="text-foreground/80 mb-1 block text-xs font-medium">
        {label}
      </Label>
      {children}
    </div>
  );
}

export function ResidentRegistrationForm() {
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success("Resident registration saved (prototype)");
  };

  return (
    <AdminShell
      title="Resident Registration Form"
      subtitle="Complete resident registration screen for approved admissions"
      actions={
        <Button form="resident-registration-form" size="sm">
          <Save className="mr-1 h-3.5 w-3.5" /> Save Registration
        </Button>
      }
    >
      <form
        id="resident-registration-form"
        onSubmit={onSubmit}
        className="space-y-4"
      >
        <SectionCard title="Basic Information">
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <F label="Full Name">
              <Input />
            </F>
            <F label="Mobile Number">
              <Input type="tel" />
            </F>
            <F label="Address" full>
              <Textarea rows={2} />
            </F>
          </div>
        </SectionCard>

        <SectionCard title="Financial Information">
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <F label="Annual Income">
              <Input type="number" />
            </F>
            <F label="Pension Amount">
              <Input type="number" />
            </F>
            <F label="Children Information" full>
              <Textarea rows={2} />
            </F>
          </div>
        </SectionCard>

        <SectionCard title="Identity Information">
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
            <F label="Aadhaar Number">
              <Input />
            </F>
            <F label="Ration Card Number">
              <Input />
            </F>
            <F label="Election Card Number">
              <Input />
            </F>
            <F label="Ayushman Card Number">
              <Input />
            </F>
          </div>
        </SectionCard>

        <SectionCard title="Medical Information">
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <F label="Medical Details" full>
              <Textarea rows={3} />
            </F>
            <F label="Physical Condition" full>
              <Textarea rows={2} />
            </F>
          </div>
        </SectionCard>

        <FamilyDetails
          title="Family Tree Section"
          subtitle="Family tree details linked to this resident"
          initialRows={3}
        />
      </form>
    </AdminShell>
  );
}
